export const SAVED_MEAL_PREFIX = 'sml' as const;
export const SAVED_MEAL_LINE_PREFIX = 'sli' as const;
export const ID_GLUE = '_' as const;

export type SavedMealId = `${typeof SAVED_MEAL_PREFIX}${typeof ID_GLUE}${string}`;
export type SavedMealLineId = `${typeof SAVED_MEAL_LINE_PREFIX}${typeof ID_GLUE}${string}`;
